import { routes } from "../../../../app/paths";
import NewTabLink from "./NewTabLink";

type Props = {
  id: string;
  label: string;
};

export const TalentLinkLight = ({ id, label }: Props) => (
  <NewTabLink
    to={routes.talentProfile(id)}
    text={label}
    TypographyProps={{
      sx: {
        fontSize: 14,
        color: (theme) => theme.palette.primary.light,
      },
      variant: "body2",
    }}
    stopPropagation
  />
);
